import React, { Component } from 'react';
import { connect } from 'react-redux'
import { alertIconMessage, attachedFileMessage, deploBarMessage, mailIconMessage, userIconMessage } from '../../Images/Images';
import { Image } from 'react-bootstrap';
import { WINDOW_AT_500 } from '../../constants.js';
import { SingletonSharedData } from '../../js/singletonSharedData';

class MessageBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barExpanded: true,
      showAt500: false
    }
    this.resize = () => this.forceUpdate()
    this.sharedData = new SingletonSharedData();
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  changeSizeBar = () => {
    this.setState({ barExpanded: !this.state.barExpanded });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.windowVisible500.windowVisible === WINDOW_AT_500.MESSAGE) {
      this.setState({ showAt500: true });
    } else {
      this.setState({ showAt500: false });
    }

    this.setState({
      currentState: nextProps.userState.currentState
    });
  }

  renderContractedMessages() {
    var messages = [];
    for (var i = 0; i < 10; i++) {
      messages.push(
        <div className="MessageItemSmall" key={"item" + i}>
          <div className="NoReadBar">
          </div>
          <Image src={userIconMessage} className="userIconMessageSmall" />
          <div className="TimeMessageSmall">
            <p className="TimeTextMessageSmall">00:00:05</p>
          </div>
          <div className="TypeMessageInfoSmall">
            <Image src={mailIconMessage} className="iconTypeMessageSmall" />
            <Image src={attachedFileMessage} className="iconTypeMessageSmall" />
            <Image src={alertIconMessage} className="iconTypeMessageSmall" />
          </div>
        </div>
      );
    }
    return messages;
  }

  renderExpandedMessages() {
    var messages = [];
    for (var i = 0; i < 10; i++) {
      messages.push(
        <div className="MessageItem" key={"item" + i}>
          <div className="NoReadBar">
          </div>
          <div className="GralInfoMessage">
            <div className="GralInfoMessageContainer">
              <Image src={userIconMessage} className="userIconMessage" />
              <p className="userNameMessage">Nombre de usuario 0100000000</p>
              <p className="subjectMessage">Grupo ACD 01</p>
            </div>
          </div>
          <div className="TypeMessageInfo">
            <Image src={mailIconMessage} className="iconTypeMessage" />
            <Image src={attachedFileMessage} className="iconTypeMessage" />
            <Image src={alertIconMessage} className="iconTypeMessage" />
          </div>
          <div className="SubjectMessage">
            <p className="SubjectTextMessage">Asunto del mail...</p>
          </div>
          <div className="TimeMessage">
            <p className="TimeTextMessage">00:00:05</p>
          </div>
        </div>
      );
    }
    return messages;
  }

  classNameMB() {
    var str = "";
    if (this.sharedData.isInCallState(this.state.currentState)) {//IS IN CALL STATE
      str = this.state.barExpanded ? "messageBarExpanded expandenInCall" : "messageBarContracted";
      if (this.state.showAt500) {
        str += " showMessage500";
      } else {
        str += " hidenMessage500";
      }
    } else {//NOT CALL
      str = this.state.barExpanded ? "messageBarExpanded" : "messageBarContracted";
      if (this.state.showAt500) {
        str += " showMessage500";
      } else {
        str += " hidenMessage500";
      }
    }
    return str;
  }

  renderMessages() {
    if (this.sharedData.isInCallState(this.state.currentState)) {//IS IN CALL STATE
      if (!this.state.barExpanded || window.innerWidth < 850) {
        return this.renderContractedMessages();
      } else {
        return this.renderExpandedMessages();
      }
    } else {//NOT CALL STATE
      if (!this.state.barExpanded) {
        return this.renderContractedMessages();
      } else {
        return this.renderExpandedMessages();
      }
    }
  }

  render() {
    return (
      <div className={this.classNameMB()}>
        <div className="ExpandBar" onClick={this.changeSizeBar}>
          <Image src={deploBarMessage} className="deployBarMessage" />
        </div>
        <div className="MessageArea">
          {this.renderMessages()}
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    userState: state.userState,
    windowVisible500: state.windowVisible500
  }
}

export default MessageBar = connect(
  mapStateToProps,
  null
)(MessageBar);



// WEBPACK FOOTER //
// ./src/components/workSpace/messageBar.jsx